import { useMutation } from '@tanstack/react-query'
import { ExtendableMutationOptions } from 'shared/api/api.types'

import { forgeApi } from '../..'
import { UnshareArtifactRequest } from './unshareArtifact.types'

export const unshareArtifact = async ({
  publicId,
  userIds
}: UnshareArtifactRequest): Promise<void> => {
  // forge expects the recipients in the request body, so use axios' config form.
  await forgeApi.delete(
    `/api/v1/artifacts/${encodeURIComponent(publicId)}/shares`,
    { data: { user_ids: userIds } }
  )
}

export const useUnshareArtifactMutation = (
  options?: ExtendableMutationOptions<void, UnshareArtifactRequest>
) =>
  useMutation({
    mutationFn: unshareArtifact,
    ...options
  })
